<template>
  <div>
    <q-card v-if="edit">
      <slot :model-value="form" />
    </q-card>
    <q-list bordered separator>
      <template v-for="item in modelValue" :key="item">
        <q-item clickable v-ripple>
          <q-item-section>
            <slot name="item" :model-value="item" />
          </q-item-section>
          <q-item-section class="col-1" v-if="edit">
            <q-btn flat icon="delete_outline" @click.stop="remove(item)" />
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </div>
</template>

<script setup>
import {
  defineProps,
  ref,
  defineEmits,
  getCurrentInstance,
  computed,
  onMounted
} from "vue";

const props = defineProps({ modelValue: { type: Array } });
const emit = defineEmits(["update:modelValue"]);

const form = ref();

const instance = getCurrentInstance();
const formParent = p =>
  !p.parent || p.parent.type.__name == "AppEditForm"
    ? p.parent
    : formParent(p.parent);
const editForm = formParent(instance.parent);
const edit = computed(() => editForm?.exposed?.edit.value );
emit
const remove = item => {
  emit("update:modelValue", props.modelValue.filter(e => e !== item));
}


onMounted(() => {
  emit("update:modelValue", []);
});

</script>
